import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import Loader from 'components/shared/Loader'
import newLoader from 'assets/icons/new-loader.png'
import paymentImage from 'assets/images/tickets/payment.svg'
import { Image, LoaderWrapper } from 'routes/PaymentConfirmation/styles'

interface ProcessingPageProps {
    shouldShowProcessing?: boolean
    shouldShowProcessingDragsOn?: boolean
}

export const ProcessingPage = ({
    shouldShowProcessing = true,
    shouldShowProcessingDragsOn,
}: ProcessingPageProps) => (
    <Box isFullWidth align="center" mt={[64, 74]}>
        {shouldShowProcessing && (
            <>
                <Image src={paymentImage} alt="" />
                <Text
                    variant="heading2"
                    color="secondary_500"
                    mb={16}
                    mt={[16, 24]}
                    align="center"
                >
                    <FormattedMessage
                        id="global.payments.payment_processing"
                        defaultMessage="Przetwarzamy Twoją płatność"
                    />
                </Text>
            </>
        )}
        {shouldShowProcessing && shouldShowProcessingDragsOn && (
            <Text
                variant="bodyLarge"
                align="center"
                color="grayscale_900"
                mb={[24, 32]}
            >
                <FormattedMessage
                    id="global.payments.payment_processing_please_wait"
                    defaultMessage="To może potrwać kilka minut. Nie zamykaj okna przeglądarki."
                />
            </Text>
        )}
        <LoaderWrapper isCentered={!shouldShowProcessing}>
            <Loader src={newLoader} />
        </LoaderWrapper>
    </Box>
)
